"use strict";

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkErrors = function (columns) {
  var hasGroups = !!columns.find(function (column) {
    return column.parent;
  });
  var stickyColumnsWithoutGroup = columns.filter(function (column) {
    return column.sticky && !column.parent;
  }).map(function (_ref) {
    var Header = _ref.Header;
    return "'".concat(Header, "'");
  });
  if (hasGroups && stickyColumnsWithoutGroup.length) {
    throw new Error("WARNING react-table-sticky:\n      \nYour ReactTable has group and sticky columns outside groups, and that will break UI.\n      \nYou must place ".concat(stickyColumnsWithoutGroup.join(' and '), " columns into a group (even a group with an empty Header label)\n"));
  }
  var bugWithUnderColumnsSticky = columns.find(function (parentCol) {
    return !parentCol.sticky && parentCol.columns && parentCol.columns.find(function (col) {
      return col.sticky;
    });
  });
  if (!bugWithUnderColumnsSticky) return;
  // @ts-ignore
  var childBugs = bugWithUnderColumnsSticky.columns.find(function (_ref2) {
    var sticky = _ref2.sticky;
    return sticky;
  });
  if (!childBugs) return;
  throw new Error("WARNING react-table-sticky:\n    \nYour ReactTable contain columns group with at least one child columns sticky.\n    \nWhen ReactTable has columns groups, only columns groups can be sticky\n    \nYou must set sticky: 'left' | 'right' for the '".concat(bugWithUnderColumnsSticky.Header, "'\n    column, or remove the sticky property of '").concat(childBugs.Header, "' column."));
};
function getStickyValue(column) {
  if (column.sticky === 'left' || column.sticky === 'right') {
    return column.sticky;
  }
  if (column.parent) {
    return getStickyValue(column.parent);
  }
  return null;
}
exports.getStickyValue = getStickyValue;
function columnIsLastLeftSticky(columnId, columns) {
  var index = columns.findIndex(function (_ref3) {
    var id = _ref3.id;
    return id === columnId;
  });
  var column = columns[index];
  var nextColumn = columns[index + 1];
  var columnIsLeftSticky = getStickyValue(column) === 'left';
  var nextColumnIsLeftSticky = nextColumn && getStickyValue(nextColumn) === 'left';
  return columnIsLeftSticky && !nextColumnIsLeftSticky;
}
exports.columnIsLastLeftSticky = columnIsLastLeftSticky;
function columnIsFirstRightSticky(columnId, columns) {
  var index = columns.findIndex(function (_ref4) {
    var id = _ref4.id;
    return id === columnId;
  });
  var column = columns[index];
  var prevColumn = columns[index - 1];
  var columnIsRightSticky = getStickyValue(column) === 'right';
  var prevColumnIsRightSticky = prevColumn && getStickyValue(prevColumn) === 'right';
  return columnIsRightSticky && !prevColumnIsRightSticky;
}
exports.columnIsFirstRightSticky = columnIsFirstRightSticky;
function getMarginRight(columnId, columns) {
  var currentIndex = columns.findIndex(function (_ref5) {
    var id = _ref5.id;
    return id === columnId;
  });
  var rightMargin = 0;
  for (var i = currentIndex + 1; i < columns.length; i += 1) {
    if (columns[i].isVisible !== false) {
      rightMargin += columns[i].width;
    }
  }
  return rightMargin;
}
exports.getMarginRight = getMarginRight;
var cellStylesSticky = {
  // hard coded inline style will be remove in the next major release
  position: 'sticky',
  zIndex: 3
};
function findHeadersSameLevel(header, headers) {
  return headers.filter(function (flatHeaderItem) {
    return flatHeaderItem.depth === header.depth;
  });
}
function getStickyProps(header, instance) {
  var style = {};
  var dataAttrs = {};
  exports.checkErrors(instance.columns);
  var sticky = getStickyValue(header);
  if (sticky) {
    style = Object.assign({}, cellStylesSticky);
    // @ts-ignore
    dataAttrs['data-sticky-td'] = true;
    var headers = findHeadersSameLevel(header, instance.flatHeaders);
    var margin = sticky === 'left' ? header.totalLeft : getMarginRight(header.id, headers);
    style = Object.assign(Object.assign({}, style), _defineProperty({}, sticky, "".concat(margin, "px")));
    var isLastLeftSticky = columnIsLastLeftSticky(header.id, headers);
    if (isLastLeftSticky) {
      // @ts-ignore
      dataAttrs['data-sticky-last-left-td'] = true;
    }
    var isFirstRightSticky = columnIsFirstRightSticky(header.id, headers);
    if (isFirstRightSticky) {
      // @ts-ignore
      dataAttrs['data-sticky-first-right-td'] = true;
    }
  }
  return Object.assign({
    style: style
  }, dataAttrs);
}
exports.useSticky = function (hooks) {
  hooks.getHeaderProps.push(function (props, _ref6) {
    var instance = _ref6.instance,
      column = _ref6.column;
    var nextProps = getStickyProps(column, instance);
    return [props, nextProps];
  });
  hooks.getCellProps.push(function (props, _ref7) {
    var instance = _ref7.instance,
      cell = _ref7.cell;
    var nextProps = getStickyProps(cell.column, instance);
    return [props, nextProps];
  });
};
exports.useSticky.pluginName = 'useSticky';